import { render, staticRenderFns } from "./MobDrawerMenuItem.vue?vue&type=template&id=3b4ea3ba&scoped=true"
import script from "./MobDrawerMenuItem.vue?vue&type=script&setup=true&lang=js"
export * from "./MobDrawerMenuItem.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MobDrawerMenuItem.vue?vue&type=style&index=0&id=3b4ea3ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4ea3ba",
  null
  
)

export default component.exports